import { Card } from "antd";

import { PrimaryText } from "@/shared/ui/Typography";

interface RouteDescriptionBlockProps {
    description: string;
}

export const RouteDescriptionBlock = ({
    description,
}: RouteDescriptionBlockProps) => {
    return (
        <Card styles={{ body: { padding: 16 } }}>
            <PrimaryText>{description}</PrimaryText>
        </Card>
    );
};
